<template>

    <div class="mainclass">
        <my-header title="组织选择"></my-header>
        <div class="select_btn">
            <Select   label="单选select"
                      title="请选择组织"
                      value-key="leagueName"

                      :columns="options2_"
                      :option="{label:'leagueName',value:'leagueId'}"
                      @confirm="onChange2">



            </Select>
            <Select   label="单选select"
                      title="请选择组织"
                      value-key="leagueName"
                      :selectValue="value3"
                      :columns="options3_"
                      :option="{label:'leagueName',value:'leagueId'}"
                      @confirm="onChange3">

            </Select>
            <Select   label="单选select"
                      title="请选择组织"
                      value-key="leagueName"
                      :selectValue="value4"
                      :columns="options4_"
                      :option="{label:'leagueName',value:'leagueId'}"
                      @confirm="onChange4">

            </Select>
        </div>
        <div class="search_wrap">
            <van-search v-model="searchValue" shape="round" show-actionplaceholder="请输入搜索关键词" />
            <van-button color="#66b1ff" style="border-radius: 5px;height: 30px;width: 80px" size="small"
                        @click="onSearch"  loading-type="spinner">搜索</van-button>
        </div>
        <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                finished-text="没有更多了"
                @load="onLoad"
        >

            <van-cell v-for="item in listData_"  :key="item.leagueId" @click="chooseOrg(item)" :title="item.leagueFullName" >

            </van-cell>
        </van-list>


    </div>
</template>

<script>
    // import {SET_PARAMS} from "../../store/mutations";
    import Select from "../../components/Select"
    import MyHeader from '../../components/MyHeader'
    import Dialog from "vant";
    export default {
        name: "OrgList",
        components: {
            MyHeader,
            Select,
        },
        data() {
            return {
                show:false,
                isAdmin:false,
                finished: false,
                dataList: [],
                popupVisible: false,
                queryLeagueId_:'-1',
                searchValue: '',
                value1:"-1",
                value4:"",
                value3:"",
                selectLeague: null,
                selectIndex: -2,
                leagueList:[],
                UpLeagueList: [],
                loading: false,
                page: 1,
                searchKey:'',
                listData_: [],
                options2_:[],
                options3_:[],
                options4_:[],
                optionsData_:[],
                rowsPrePage: 5,
                totalRows: 0,

            }
        },
        computed: {

            hasNext() {
                if (this.selectLeague != null && this.selectLeague.hasChildLeague == 1)
                    return true
                else
                    return false
            },
            rightTitle() {
                if (this.selectLeague&&this.selectLeague.leagueTypeId == '01TZB') {
                    return '完成'
                } else if (this.UpLeagueList.length > 0) {
                    return '上一步'
                } else {
                    return ''
                }
            }
        },
        created() {

            this.loadOptions2(2)
        },
        methods: {
            // onSearch(value){
            //
            // },
            onSearch() {
                this.doSearch()
            },
            doSearch(p) {
                console.log("doSearch:"+p)
                if (!p) {
                    this.listData_=[]

                    p = 1

                }
                if(p==1){
                    this.finished=false
                }
                this.loading=true
                let self = this
                let param = {
                    currLeagueId: '',
                    queryLeagueId: this.queryLeagueId_,
                    logined:0,
                    leagueTypeId: "01TZB,03TW,02TZZ,04TGW,05TDLDJG,06BYBTZB",
                    leagueId: this.queryLeagueId_,
                    leagueName: this.searchValue,
                    pageNumber:10,
                    isTzb: 1,
                    curPage: p,
                }
                //let d = JSON.stringify(param)
                console.log(param)
                console.log('iaAdmin::::' + this.isAdmin)
                //console.log('cons.u:' + cons.u)
                this.$root.PF('/orgPickSearch', param, {})
                    .then(function (response) {
                        self.loading=false
                        if (response.status == 200) {
                            if (response.data.retCode === 1000) {
                                //alert('ok,submit success!')
                                if(response.data.results.leagueList&&response.data.results.leagueList.length>0){
                                    self.listData_ =self.listData_.concat(response.data.results.leagueList)
                                }
                                self.totalRows = response.data.results.totalNumber
                                self.page = response.data.results.page
                                self.rowsPrePage = response.data.results.pageNumber

                                if (self.totalRows<=10) {
                                    self.finished=true

                                }
                                //console.log(self.pageData)
                                //console.log('store state leagueName:' + self.$store.state.user.userSex)
                            } else {
                                self.listData_ = []
                                self.$dialog.alert({
                                    message: response.data.retMsg,
                                    theme: 'round-button',
                                }).then(() => {
                                    // on close
                                });
                                // self.$notify({
                                //     type: 'danger',
                                //
                                //     message: response.data.retMsg
                                // })
                                console.log("reCode:" + response.data.retCode)
                                self.loading = false
                            }
                        } else {
                            self.loading = false
                            console.log("Got Return code:" + response.status)
                        }
                    })
                    .catch(function (error) {
                        self.loading = false
                        self.listData_ = []
                        self.$toast.clear()

                        console.log(error.config);
                    });
            },
            chooseOrg(info){
                this.$store.commit('SET_PARAMS', {'orgPick': info})
                this.go(-1)
            },
            onChange2(value, index) {

                if (!this.isAdmin){
                    var message=''
                    if (this.businessType==1){
                        switch (value.leagueId) {
                            case this.BJId:
                                message='操作错误，若组织关系需要转往北京／广东／福建，在“转入组织是否属于北京／广东／福建”时，应选择“是”'
                                break
                            case this.GDId:
                                message='操作错误，若组织关系需要转往北京／广东／福建，在“转入组织是否属于北京／广东／福建”时，应选择“是”'
                                break
                            case this.FJId:
                                message='操作错误，若组织关系需要转往北京／广东／福建，在“转入组织是否属于北京／广东／福建”时，应选择“是”'
                                break
                        }
                    }else {
                        switch (value.leagueId) {
                            case this.BJId:
                                message='北京市的团员请使用北京市的系统注册。'
                                break
                            case this.GDId:
                                message='广东省的团员请使用广东省的系统注册。'
                                break
                            case this.FJId:
                                message='福建省的团员请使用福建省的系统注册。'
                                break
                        }
                    }
                    if (message.length>0){
                        this.listData_=[]
                        this.$toast.fail(message);

                        return
                    }
                }
                this.queryLeagueId_ = value.leagueId
                this.value3=""
                this.value4=""
                this.loadOptions2(3)
                this.options4_=[]
                //this.listData_ = this.options3_
            },
            onChange3(value,index) {
                var v=value.leagueId
                if (v.length == 0) {

                } else{
                    this.queryLeagueId_ = v
                    this.value3=v
                    this.value4=""
                }
                this.loadOptions2(4)
                this.value4=""
                //this.listData_ = this.options4_
            },
            onChange4(value,index) {
                var v=value.leagueId
                if (v.length == 0) {

                } else{
                    this.queryLeagueId_ = v
                    this.value4=v
                }

                this.loadOptions2(5)
                //this.listData_ = this.optionsData_
            },

            loadOptions2(which) {
                this.finished=false
                if ( which == 2 && this.options2_.length > 1) {
                    return
                }
                let self = this
                this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: "加载中..."
                });
                let param = {
                    queryLeagueId: this.queryLeagueId_,
                    leagueTypeId: "01TZB,03TW,02TZZ,04TGW,05TDLDJG,06BYBTZB",
                    leagueId: this.queryLeagueId_,
                    leagueName: this.searchValue,
                    isTzb:1,
                    pageNumber:10,
                    curPage:0
                }
                this.$root.PF('/orgpickinit', param, {})
                    .then(function (response) {
                        self.$toast.clear()
                        if (response.status == 200) {
                            if (response.data.retCode === 1000) {
                                if (which == 2) {
                                    self.options2_ = response.data.results.P1.leagueList
                                } else if (which == 3) {
                                    self.options3_ = response.data.results.P1.leagueList
                                } else if (which == 4) {
                                    self.options4_ = response.data.results.P1.leagueList
                                } else if (which == 5) {
                                    // self.optionsData_ = response.data.results.leagueList
                                    self.optionsData_ = response.data.results.P1.leagueList
                                } else {
                                    self.options2_ = response.data.results.P1.leagueList
                                }
                                if (which > 2) {
                                    // self.listData_ = response.data.results.P2.leagueList
                                    self.doSearch()
                                }
                                self.totalRows = response.data.results.P2.totalNumber
                                self.page = response.data.results.P2.page
                                self.rowsPrePage = response.data.results.P2.pageNumber
                                if ( self.totalRows<=10) {
                                    self.finished=true
                                }
                                self.BJId=response.data.results.bjId
                                self.FJId=response.data.results.fjId
                                self.GDId=response.data.results.gdId
                            } else {
                                self.listData_ = []
                                self.totalRows =0
                                this.$dialog.alert({
                                    message: response.data.retMsg,
                                    theme: 'round-button',
                                })
                                // self.$toast.fail({
                                //     message: response.data.retMsg
                                // })
                                console.log("reCode:" + response.data.retCode)
                            }
                        } else {
                            self.listData_ = []
                            console.log("Got Return code:" + response.status)
                        }
                    }).catch(function (error) {
                    self.$toast.clear()
                });
            },

            goNext() {
                this.selectIndex = -2
                this.UpLeagueList.push(this.selectLeague)
                this.fetchData()
            },


            onLoad() {
                this.loading = true
                if (this.page * this.rowsPrePage < this.totalRows) {
                    this.page++
                    this.doSearch(this.page)
                }else {
                    this.finished=true
                }
            },


            //
            // itemClick(item, index) {
            //     this.selectIndex = index;
            //     this.selectLeague = item
            //     if (item.hasChildLeague == 1) {
            //         this.UpLeagueList.push(item)
            //         this.fetchData()
            //     } else if (item.leagueTypeId != '01TZB') {
            //         this.$toast('该组织不是团支部')
            //     }
            // }


        },
    }
</script>

<style scoped>
    .mainclass{
        margin-top: 50px;
        padding: 0;
    }

    .select_btn{
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .search_wrap {
        padding: 10px 10px 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    .search_wrap .van-search {
        background-color: transparent;
        flex: 0 0 80%;
    }

    /deep/ .select_btn .van-button--normal{
        margin-top: 10px;
    }
    /deep/ .search_wrap .van-button--normal {
        height: 30px;
        width: 60px;
        border-radius: 5px;
    }
</style>
